<div class="chargepoint-page">
  <app-chargepoint-card [chargepoint]="chargepoint" [hideActions]="true" class="chargepoint-identity sticky"></app-chargepoint-card>

  <mat-card class="chargepoint-quick-actions sticky">
    <mat-card-header>
      <mat-card-title>Quick Actions</mat-card-title>
    </mat-card-header>
    <mat-card-content class="chargepoint-quick-actions-content">
      <button mat-icon-button matTooltip="Inspect json" (click)="jsonViewerService.openJsonViewer(chargepoint)">
        <mat-icon>data_object</mat-icon>
      </button>
      <button mat-icon-button color="primary" matTooltip="View logs" (click)="showLogsDialog()">
        <mat-icon>article</mat-icon>
      </button>
      <div class="spacer"></div>
      <button mat-icon-button matTooltip="Start transaction" (click)="startTransaction()" [disabled]="chargepoint.status !== 'AVAILABLE'">
        <mat-icon>play_arrow</mat-icon>
      </button>
      <button mat-icon-button matTooltip="Check connectivity" (click)="checkConnectivity()">
        <mat-icon>network_ping</mat-icon>
      </button>
    </mat-card-content>
  </mat-card>

  <mat-card class="chargepoint-plug-info">
    <mat-card-header>
      <mat-card-title>Plug info</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <mat-progress-bar *ngIf="loadingPlugInfo" mode="indeterminate"></mat-progress-bar>
      <p *ngIf="plugInfoError">Failed to load plug info.</p>
      <ng-container *ngIf="plugInfo$ | async as plugInfo">
        <div class="info-grid" *ngIf="plugInfo">
          <app-copiable-info label="Internal ID" icon="fingerprint" [value]="plugInfo.plug.id"></app-copiable-info>
          <app-copiable-info label="OCell ID" icon="outlet" [value]="plugInfo.plug.ocellId"></app-copiable-info>
          <app-copiable-info label="Status" icon="info" [value]="plugInfo.plug.status ?? 'Unknown'"></app-copiable-info>
          <app-copiable-info label="Last transaction" icon="receipt_long" [value]="plugInfo.plug.lastTransactionId ?? 'None'"></app-copiable-info>
        </div>
        <mat-divider *ngIf="plugInfo.lastTransaction"></mat-divider>
        <div class="last-transaction" *ngIf="plugInfo.lastTransaction as transaction">
          <h4>Last transaction</h4>
          <div class="info-grid">
            <app-copiable-info label="Transaction ID" icon="tag" [value]="transaction.id"></app-copiable-info>
            <app-copiable-info label="Status" icon="info" [value]="transaction.status"></app-copiable-info>
            <app-copiable-info label="Energy (Wh)" icon="bolt" [value]="transaction.energy != null ? transaction.energy.toString() : '—'"></app-copiable-info>
          </div>
        </div>
      </ng-container>
    </mat-card-content>
  </mat-card>

  <mat-card class="chargepoint-relay-state">
    <mat-card-header>
      <mat-card-title>Relay state</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <mat-progress-bar *ngIf="loadingRelayState" mode="indeterminate"></mat-progress-bar>
      <p *ngIf="relayStateError">Failed to load relay state.</p>
      <ng-container *ngIf="relayStates$ | async as relayStates">
        <div class="info-grid" *ngIf="relayStates?.length">
          <app-copiable-info label="Sensor ID" icon="sensors" [value]="relayStates[0].SensorId"></app-copiable-info>
          <app-copiable-info label="Last update" icon="schedule" [value]="getLatestRelayTimestamp(relayStates) ?? '—'"></app-copiable-info>
          <ng-container *ngIf="getRelayStateDisplay(relayStates) as relay">
            <div
              class="relay-state-indicator relay-state-indicator--{{ relay.statusClass }}"
              [matTooltip]="'relay_state = ' + (relay.raw ?? '—')"
            >
              <mat-icon>{{ relay.icon }}</mat-icon>
              <div class="relay-state-indicator__text">
                <span class="relay-state-indicator__label">
                  {{ relay.label }}
                  <span class="relay-state-indicator__raw">({{ relay.raw ?? '—' }})</span>
                </span>
                <span class="relay-state-indicator__description">{{ relay.description }}</span>
              </div>
            </div>
          </ng-container>
        </div>
        <p *ngIf="relayStates && !relayStates.length">No relay state data available.</p>
      </ng-container>
    </mat-card-content>
  </mat-card>

  <mat-card class="chargepoint-connectivity" *ngIf="connectivityCheck$ | async as check">
    <mat-card-header>
      <mat-card-title>Connectivity check</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <div class="info-grid">
        <app-copiable-info label="Ready" icon="check_circle" [value]="check.isReady ? 'Yes' : 'No'"></app-copiable-info>
        <app-copiable-info label="OCell API" icon="cloud" [value]="check.checks.callToOcellApiSucceeded ? 'OK' : 'Failed'"></app-copiable-info>
        <app-copiable-info label="Plug found" icon="search" [value]="check.checks.ocellFoundPlug ? 'Yes' : 'No'"></app-copiable-info>
        <app-copiable-info label="Recent info" icon="update" [value]="check.checks.hasPlugSentRecentInfo ? 'Yes' : 'No'"></app-copiable-info>
      </div>
    </mat-card-content>
  </mat-card>

  <mat-card class="chargepoint-transactions">
    <mat-card-header>
      <mat-card-title>Transactions</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <app-transactions-list [chargepoint]="chargepoint"></app-transactions-list>
    </mat-card-content>
  </mat-card>
</div>
